import { createContext } from 'react';

const DialogContext = createContext({
    fullscreen: false,
});

export { DialogContext as default };
//# sourceMappingURL=DialogContext.js.map
